import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from 'reactstrap';
import { is } from 'immutable'
import { 
  onSaleRef,
  historyRef, 
  userRef,
  REST_API_URL
   } from '../../config'
import React, { Component } from 'react'
import moment from 'moment'
import ReactToolTip from 'react-tooltip'
import  agent  from 'superagent-bluebird-promise'
import { Link } from 'react-router-dom'
import { eliminateDuplicates } from '../../utils'
import Promise from 'bluebird'


class OnSaleList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      loading: false,
      onSaleItems: [],
      count: 1000,
      year: '2017',
      startTime: 'all',
      startDate: moment().format('MM/DD/YY'), //today
      startIndex: 0,
      endIndex: 10,
      query: '',
      recommendedBuys: {},
      showDetailModal: false,
      itemBeingEdited: null,
      itemChanges: {},
      selectedItem: null,
      editing: false
    }
    this.filterItems = this.filterItems.bind(this)
    this.toggle = this.toggle.bind(this)
    this.toggleEdit = this.toggleEdit.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.handleStartTime = this.handleStartTime.bind(this)
    this.handleStartDate = this.handleStartDate.bind(this)
    this.getAndRegisterPercent = this.getAndRegisterPercent.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleNumTicketsChange = this.handleNumTicketsChange.bind(this)
    this.removeDuplicateData = this.removeDuplicateData.bind(this)
    this.testAi = this.testAi.bind(this)
    //this.startSimulation = this.startSimulation.bind(this)
  }

  componentDidMount() {
    this.setState({spinner: true})
    setTimeout(()=>{
        this.fetchUpdatedData(this.state.startDate)
    },2)
  }

  handleScroll(e) {
    let lastValue;
    let onSaleItems = [];
    if(e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight) {
        this.setState({
            endIndex: this.state.endIndex + 10
        })
    }

  }

  handleStartTime(e) {
    this.setState({
      startTime: e.target.value,
      endIndex: 10,
      startIndex: 0
    })
  }
  handleStartDate(e) {
    this.setState({
      startDate: e.target.value,
      endIndex: 10,
      startIndex: 0
    })
  }
  componentWillUnMount() {
    onSaleRef.off()
  }

  fetchUpdatedData = (date) => {
      let onSaleItems = []
      onSaleRef
        .orderByChild("onSaleDate")
        .startAt(date)
        .endAt(moment().add(2, 'day').format('MM/DD/YY'))
        .once('value', s => {
          if (s.exists()) {
            Object.keys(s.val()).map(k => {
                onSaleItems.push(Object.assign({}, s.val()[k], { id: k }))
            })
          }
        }).then(() => {
          this.setState({
            onSaleItems:[...this.state.onSaleItems, ...onSaleItems],
            spinner: false,
            loading: false
          })
          this.removeDuplicateData()
        })
  }


  // remove duplicate events from the on sale items
  removeDuplicateData() {
    this.getDataForTwoDays();
  }

  testAi() {
    console.log(this.state.onSaleItems.length)
    let promises = Promise.map(this.state.onSaleItems, item => {
      console.log(item)
      let {eventName , venue} = item
      return agent
      .post(REST_API_URL+'/ai')
      .send({
        artist: item.eventName,
        venue: item.venue
      })
      .then(res => {
        console.log('test ai res', res)
      })
      .catch(console.log)
    })
    Promise.all(promises)
    .then(console.log)
   

  }
  startSimulation = () => {
    let totalProfit = 0
    let avgProfit = 0
    let bestTicketProfit = 0
    let sampleSize = 0
    let estimatedProfit = 0
    let worstSale = 0
    let profitAfterFees = 0
    let profitObj = this.state.history[this.state.venue.label+this.state.artist.label] !== undefined ? this.state.history[this.state.venue.label+this.state.artist.label]: undefined
    if(this.state.history[this.state.venue.label+this.state.artist.label] !== undefined) {
      this.setState({result: profitObj})
      return
    }
    for(let i =0; i< 100; i++) {
      let thisProfit = Math.random() * 100
      if(thisProfit > bestTicketProfit)
        bestTicketProfit = thisProfit
      totalProfit += thisProfit
    }
    avgProfit = Math.floor(Math.round(totalProfit / 100))
    sampleSize = Math.floor(Math.round(Math.random()*100))
    estimatedProfit = Math.floor(Math.round((totalProfit - Math.random())))
    worstSale = Math.floor(Math.round(bestTicketProfit - (bestTicketProfit*0.5)))
    profitAfterFees = Math.floor(Math.round(estimatedProfit - (estimatedProfit*0.10)))
    profitObj = {
      avgProfit,
      sampleSize,
      estimatedProfit,
      profitAfterFees,
      totalProfit: Math.round(totalProfit),
      worstSale,
      bestTicketProfit
    }
    //this.state.history[this.state.venue.label + this.state.artist.label] = profitObj
    this.setState({result: profitObj, showResults: true, guess:true})
    
  }

  getDataForTwoDays() {
    let onSaleItemsScrap = this.state.onSaleItems;
    let filteredDataItems = onSaleItemsScrap
    // let filteredDataItems = onSaleItemsScrap.filter(item => new Date(item.onSaleDate) > new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000)))
    var filterObject = [];
    var globalIndex;
    let ObjectPassword,
      dataArrayPassword;
    let count = 0;
    for (var i = 0, l = filteredDataItems.length; i < l; i++) {

      if (
        filterObject.map(x => (x.city + '|' + x.eventDate + '|' + x.onSaleTime + '|'+ x.eventName + '|' + x.venue))
          .indexOf(filteredDataItems[i].city + '|' +
          filteredDataItems[i].eventDate + '|' +
          filteredDataItems[i].onSaleTime + '|'+ filteredDataItems[i].eventName + '|' + filteredDataItems[i].venue)
        === -1
      ) {
        let passwordUnified = filteredDataItems.filter(x => x.city === filteredDataItems[i].city && x.eventName === filteredDataItems[i].eventName
                && x.venue === filteredDataItems[i].venue && x.eventDate === filteredDataItems[i].eventDate).map(y => y.password)
        let uniqueItems = Array.from(new Set(passwordUnified)).join("\nNew :- ").split('<br />').join("\n")
        filteredDataItems[i].password = uniqueItems;
        filterObject.push(filteredDataItems[i]);
      }
    }
    let onSaleItems = filterObject;
    this.setState({
      onSaleItems: onSaleItems
    })
    return onSaleItems;
  }

  getAndRegisterPercent = (item) => {
    let val = Math.floor(Math.random() * 100)
    historyRef.push({[item]: val})
    .then(() => {
      this.setState({
        history: Object.assign({}, this.state.history, { [item]: val })
      })
    })
    return val
  }
  filterItems() {
    const regex = new RegExp(this.state.query, 'gi')
    if (this.state.query.length < 3 || this.state.reset == true) {
      return this.state.onSaleItems
    }
    if ('recommended'.match(regex)) {
      return this.state.onSaleItems.filter((item, index) => {
        return item.reccommended === true
      })
    }
    return this.state.onSaleItems.filter((t, index) =>
      (t.venue.match(regex)) ||
      t.eventName.match(regex) ||
      t.city.match(regex)
    )
  }

  handleFilter = e => {
    this.setState({ query: e.target.value })
  }

  toggle(item) {
    this.setState({
      showDetailModal: !this.state.showDetailModal,
      selectedItem: item
    })
  }
  handleItemChange = e => {
    this.setState({
      itemChanges: { [this.state.itemBeingEdited.id]: Object.assign({}, this.state.itemChanges[this.state.itemBeingEdited.id], { additionalComments: e.target.value }) }
    })
  }
  handleNumTicketsChange(e) {
    this.setState({ itemChanges: { [this.state.itemBeingEdited.id]: Object.assign({}, this.state.itemChanges[this.state.itemBeingEdited.id], { numTicketsToBuy: e.target.value }) } }
    )
  } 

  toggleEdit(item) {
    let _this = this
    if (
      this.state.itemBeingEdited &&
      Object.keys(this.state.itemChanges).length > 0
    ) {
      let itemId = this.state.itemBeingEdited.id
      onSaleRef.child(this.state.itemBeingEdited.id).update(Object.assign(this.state.itemChanges[this.state.itemBeingEdited.id], { reccommended: true, reccommendedBy: localStorage.getItem('firstName') }), () => {
        this.setState({
          editing: false,
          showDetailModal: false,
          itemBeingEdited: false,
          itemChanges: {},
          recommendedBuys: Object.assign({}, this.state.recommendedBuys, { [itemId]: true })
        })
      })
    }
    this.setState({
      editing: !this.state.editing,
      showDetailModal: !this.state.showDetailModal,
      itemBeingEdited: this.state.itemBeingEdited ? null : item,
      filterOpen: false
    })
  }

  filterOpen = e => {
    this.setState({ filterOpen: !this.state.filterOpen });
    e.preventDefault();
  }

  render() {
    const onSaleTableStyle = {
      'tableLayout': 'fixed'
    }
    const spanStyles = {
      fontSize: '11px'
    }

    const yellow = {
      'background-color': '#E9D460',
      fontColor:'white'
    }
    const red = {
      'background-color': '#F22613',
      td: {
        'color': 'white'
      }
    }

    const green = {
      'background-color': '#87D37C',
      fontColor:'white'
    }

    const buildModalBody = () => {
      if (this.state.editing === true) {
        return (
          <form>
            <div className="form-group">
              <label htmlFor="numTickets"><i className='fa fa-hashtag' /> Ticket To Purchase</label>
              <div>
                <input 
                  type="text" 
                  onChange={() => this.handleNumTicketsChange()} 
                  id="numTickets" name="numTickets" 
                  className="form-control" 
                  placeholder="42" />
              </div>
            </div>
            <div className="form-group">
              <label 
                htmlFor="textarea-input"><i 
                className='fa fa-comments' /> Additional comments</label>
              <div>
                <textarea 
                id="textarea-input" 
                onChange={this.handleItemChange} 
                name="textarea-input" 
                rows="9" 
                className="form-control" placeholder="Content.."></textarea>
              </div>
            </div>
          </form>
        )
      }
      else if (this.state.selectedItem) {
        return (
          <div>
            <h4> <span 
              className='text-muted'> Recommended by:</span> {this.state.selectedItem.reccommendedBy} </h4>
            <h4> <span 
              className='text-muted'> Num Tickets To Buy:</span> {this.state.selectedItem.numTicketsToBuy} </h4>
            <h4> <span 
              className='text-muted'> Additional Comments:</span> {this.state.selectedItem.additionalComments} </h4>
          </div>
        )
      }
    }
    const buildModalHeading = () => {
      if (this.state.editing === true) {
        return (
          <div 
            className='modal-title'> <i 
            className='fa fa-thumbs-up'> </i> Recommend this item</div>
        )
      }
      else {
        return (
          <div> <i className='fa fa-question-circle'> </i> Details</div>
        )
      }
    }
    let providers = eliminateDuplicates(this.state.onSaleItems.map(item => item.provider))
    let tableHeaders = []
    providers.forEach(provider => {
      let keys = Object.keys(this.state.onSaleItems.filter(item => item.provider === provider)[0])
      keys.forEach(k => {
        if (k !== 'id' && k !== 'numTicketsToBuy' && k !== 'reccommended' && k !== 'additionalComments' && k !== 'reccommendedBy') {
          if (tableHeaders.indexOf(k) === -1)
            tableHeaders.push(k)
        }
      })
      //tableHeaders.push(Object.keys(this.state.onSaleItems.filter(item => item.provider === provider)[0]))
    })
    eliminateDuplicates(tableHeaders)
    let totalItems = [],
        itemArr = [];

    this.filterItems()
    //  below filter is filtering the data on basis of date and time provided by default in the filter dropdown-menu
    // due to which exact data is not coming for on sale list and showing less data than the actual onsale list
      .filter(item => {
        if(item.onSaleDate === this.state.startDate){
          if(this.state.startTime === "all"){
            return item
          }
          let format = 'hh:mm:ss A'
          let time = moment(item.onSaleTime, format),
            beforeTime = moment(this.state.startTime, format).subtract(10, 'seconds'),
            afterTime = moment(this.state.startTime, format).add(1, 'hours');
            if (time.isBetween(beforeTime, afterTime)) {
              return item
            }
        }
        // return item.onSaleDate === this.state.startDate && item.onSaleTime === this.state.startTime || item.onSaleTime === this.state.startTime + ' EST'
      })
      .sort((a, b) => moment(a.onSaleDate) - moment(b.onSaleDate))
      .sort((a, b) => +a.onSaleTime.split(' ')[0].split(':')[0] - +b.onSaleTime.split(' ')[0].split(':')[0])
      .map((item, index) => {
        totalItems.push(item['eventName'])
      })

    let onSaleItems = this.filterItems()
    //  below filter is filtering the data on basis of date and time provided by default in the filter dropdown-menu
    // due to which exact data is not coming for on sale list and showing less data than the actual onsale list
      .filter(item => {
        if(item.onSaleDate === this.state.startDate){
          if(this.state.startTime === "all"){
            return item
          }
          let format = 'hh:mm:ss A'
          let time = moment(item.onSaleTime, format),
            beforeTime = moment(this.state.startTime, format).subtract(10, 'seconds'),
            afterTime = moment(this.state.startTime, format).add(1, 'hours');
            if (time.isBetween(beforeTime, afterTime)) {
              return item
            }
        }
        // return item.onSaleDate === this.state.startDate && item.onSaleTime === this.state.startTime || item.onSaleTime === this.state.startTime + ' EST'
      })
      .slice(this.state.startIndex, this.state.endIndex)
      .sort((a, b) => moment(a.onSaleDate) - moment(b.onSaleDate))
      .sort((a, b) => +a.onSaleTime.split(' ')[0].split(':')[0] - +b.onSaleTime.split(' ')[0].split(':')[0])
      .map((item, index) => {
          itemArr.push(item['eventName'])
          let percent = item.percent

          //let trStyle = percent > 25 && percent < 50 ? yellow: percent < 25 ? red: green
          let trStyle
        if (this.state.recommendedBuys[item.id] !== undefined || item.reccommended !== undefined) {
          return (
            <tr key={index} style={trStyle}>
              <td> {item['eventName']}
                <br></br>
                <Link to={`/socialData/${item.eventName}`} data-for='test' data-tip='View Social Data'>
                  <ReactToolTip id='test' />
                  <i className='fa fa-info-circle' style={{ cursor: 'pointer' }} />
                </Link>
              </td>
              {Object.keys(item).map(k => {
                if (k !== 'My Notes' &&
                  k !== 'eventName' &&
                  k !== 'publicSaleUrl' &&
                  k !== 'ticketLink' &&
                  k !== 'provider' &&
                  k !== 'id' &&
                  k !== 'reccommended' &&
                  k !== 'reccommendedBy' &&
                  k !== 'numTicketsToBuy' &&
                  k !== 'additionalComments'
                ) {
                  return (<td key={k}> {item[k]} </td>)
                }
              })}
              <td>
                <a className='btn btn-primary btn-sm' target='_blank' href={item.provider === 'Stublr' ? item.publicSaleUrl : item.ticketLink} style={{ color: 'white' }}> Buy tickets </a>
              </td>
              <td></td>
              {/*<td> <p> <i className='fa fa-percent' /> {percent} </p> </td>*/}
              <td><i className='fa fa-thumbs-up' onClick={() => this.toggleEdit(item)}> </i></td>
            </tr>
          )
        }
        return (
          <tr key={index} style={trStyle}>
            <td> {item['eventName']}
              <br></br>
              <Link to={`/socialData/${item.eventName}`} data-for='test' data-tip='View Social Data'>
                <ReactToolTip id='test' />
                <i className='fa fa-info-circle' style={{ cursor: 'pointer' }} />
              </Link>
            </td>
            {Object.keys(item).map(k => {
              if (k !== 'My Notes' &&
                k !== 'eventName' &&
                k !== 'publicSaleUrl' &&
                k !== 'ticketLink' &&
                k !== 'provider' &&
                k !== 'id' &&
                k !== 'reccommended' &&
                k !== 'reccommendedBy' &&
                k !== 'numTicketsToBuy' &&
                k !== 'additionalComments'
              ) {
                return (<td key={k}> {item[k]} </td>)
              }
            })}
            <td> <a className='btn btn-primary btn-sm' target='_blank' href={item.provider === 'Stublr' ? item.publicSaleUrl : item.ticketLink} style={{ color: 'white' }}> Buy tickets </a></td>
            <td></td>
            {/*<td> <p> <i className='fa fa-percent' /> {percent}</p></td>*/}
            <td> <i className='fa fa-thumbs-up' onClick={() => this.toggleEdit(item)}> </i></td>

          </tr>
        )
      })
      .sort((a, b) => {

      })
    if (this.state.loading) {
      return (
        <div className='row'>
          fetching onsale list...
        </div>)
    }

    if (this.state.spinner){
      return (
        <div className="loader-wrap">
        <div className="loader">Loading...</div>
        </div>
      )
    }else {
    return (
      <div className='animated fadeIn'>
        <Modal isOpen={this.state.showDetailModal} toggle={this.state.editing ? this.toggleEdit : this.toggle} className={this.props.classname}>
          <ModalHeader toggle={this.state.editing ? this.toggleEdit : this.toggle}>
            {buildModalHeading()}
          </ModalHeader>
          <ModalBody>
            {buildModalBody()}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.state.editing ? this.toggleEdit : this.toggle}>Done</Button>{' '}
            <Button color="secondary" onClick={this.state.editing ? this.toggleEdit : this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>

        <div className="panel panel-default filter-box">
          <div className="panel-heading">
            <h4 className="panel-title">
              <a href="javascript:void(0)" onClick={this.filterOpen} className={this.state.filterOpen && 'open-collapse'}>Filter
                  <i className="icon ion-chevron-up pull-right"></i>
              </a>
            </h4>
          </div>
          <Collapse isOpen={this.state.filterOpen}>
            <div className="card">
              <div className="card-block">
                <div className="row">
                  <div className="col-sm-4 col-xs-12">
                    <div className="filter-view well well-sm p-2 text-center">
                      <span className="filter-icon">
                        <i className="icon ion-funnel"></i>
                      </span>
                      <h4 className="filter-view filter-red">FILTER</h4>
                      <input type="text" value={this.state.query} onChange={this.handleFilter} className="form-control" placeholder="Type something to filter events" />
                    </div>
                  </div>
                  <div className="col-sm-4 col-xs-12">
                    <div className="filter-view well well-sm p-2 text-center">
                      <span className="filter-icon">
                        <i className="icon ion-android-alarm-clock"></i>
                      </span>
                      <h4 className="filter-view filter-red">START TIME</h4>
                      <select onChange={this.handleStartTime} className="form-control" name="">
                        <option value="all"> All </option>
                        <option> 10:00 AM </option>
                        <option> 11:00 AM </option>
                        <option> 12:00 PM </option>
                        <option> 1:00 PM </option>
                        <option> 2:00 PM </option>
                        <option> 3:00 PM </option>
                        <option> 4:00 PM </option>
                        <option> 5:00 PM </option>
                        <option> 6:00 PM </option>
                        <option> 7:00 PM </option>
                        <option> 8:00 PM </option>
                        <option> 9:00 PM </option>
                        <option> 10:00 PM </option>
                        <option> 11:00 PM </option>
                        <option> 12:00 AM</option>
                        <option> 1:00 AM </option>
                        <option> 2:00 AM </option>
                        <option> 3:00 AM </option>
                        <option> 4:00 AM </option>
                        <option> 5:00 AM </option>
                        <option> 6:00 AM </option>
                        <option> 7:00 AM </option>
                        <option> 8:00 AM </option>
                        <option> 9:00 AM </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xs-12">
                    <div className="filter-view well well-sm p-2 text-center">
                      <span className="filter-icon">
                        <i className="icon ion-ios-calendar-outline"></i>
                      </span>
                      <h4 className="filter-view filter-red">START DATE</h4>
                      <select onChange={this.handleStartDate} className="form-control" name="">
                        <option> {moment().format('MM/DD/YY')} </option>
                        <option> {moment().add(1, 'day').format('MM/DD/YY')} </option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <Button color="primary" className="filter-btn" onClick={this.resetFilter}>Reset Filter</Button>
                </div> */}
              </div>
            </div>
          </Collapse>
        </div>



        {/* <span className='badge badge-success'> Showing {this.state.onSaleItems.length}</span> */}
        <span className='badge badge-success'> Showing {itemArr.length} out of {totalItems.length}</span>
        <div className="table-responsive data-view" style={{height: window.innerHeight-180}} onScroll={(e)=>this.handleScroll(e)}>

          <table className="table">
            <thead>
              <tr>
                <th> Event Name </th>
                {tableHeaders.map((k, index) => {
                  if (k !== 'My Notes' && k !== 'publicSaleUrl' && k !== 'ticketLink' && k !== 'eventName' && k !== 'provider')
                    return (<th key={index}>{k}</th>)
                })}
                <th> purchase </th>
                <th> notes </th>
                {/*<th> <i className='fa fa-percent' /> Profitable </th>*/}
                <th> <i className='fa fa-edit' /> Recommend </th>
              </tr>
            </thead>
            <tbody>
              {onSaleItems}
            </tbody>
          </table>
        </div>
      </div>

    )
  }
  }
}

export default OnSaleList



// WEBPACK FOOTER //
// ./src/views/OnSaleList/OnSaleList.js